import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const useAbTestVariantEdit = () => {
  const search = useLocation().search;
  const creationType = useSelector(state => state.agent.etc.creationType);
  const isAbTestRedirect = new URLSearchParams(search).get('redirect') === 'abTest';
  const isAbTestVariantEdit = isAbTestRedirect && creationType === 'edit';

  return { isAbTestVariantEdit, isAbTestRedirect };
};

export default useAbTestVariantEdit;
